export default __webpack_public_path__ + "static/media/RoseBouquet.85a7c041.png";